<template>
  <div class="pb-4">
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <img
            class="img-fluid"
            width="200"
            :src="publicPath() + 'freshberry_logo.svg'"
          />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item nav-item-btn">
              <router-link
                v-if="isDeliverer"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'home' }"
                >Итоги сборщика</router-link
              >
            </li>

            <li class="nav-item nav-item-btn">
              <router-link
                v-if="isAdmin"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'usersDelivery' }"
                >Сдатчики</router-link
              >
            </li>
            <li class="nav-item nav-item-btn">
              <router-link
                v-if="isAdmin || isWholesaler"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'usersReceive' }"
                >Приемщики</router-link
              >
            </li>
            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isReceiver || isAdmin"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'acceptances' }"
                >Акт приемки</router-link
              >
            </li>
            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isAdmin || isManager || isWholesaler || isManagerFB"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'transfers' }"
                >Акт передачи</router-link
              >
            </li>

            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isAdmin || isManager || isWholesaler  || isDriver"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'shipments' }"
                >Акт перемещения</router-link
              >
            </li>

            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isAdmin || isManager"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'writeoffs' }"
                >Акт списания</router-link
              >
            </li>

            <li class="nav-item nav-item-btn">
              <router-link
                v-if="isReceiver || isAdmin || isManager"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'home' }"
                >Отчет приемки</router-link
              >
            </li>
            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isAdmin || isManager || isWholesaler || isManagerFB"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'reportMaster' }"
                >Отчет по оптовику</router-link
              >
            </li>
            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isReceiver || isAdmin"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'prices' }"
                >Цены на ягоду</router-link
              >
            </li>
            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isAdmin"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'berries' }"
                >Ягода</router-link
              >
            </li>
            <li class="nav-item justify-content-end nav-item-btn">
              <router-link
                v-if="isReceiver || isAdmin"
                class="nav-link active"
                aria-current="page"
                :to="{ name: 'bonusReceiver' }"
                >Бонусы приемщиков</router-link
              >
            </li>
            

            <li v-if="userName" class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ userName }}
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li class="nav-item nav-item-btn">
                  <router-link
                    class="dropdown-item"
                    :to="{ name: 'profile' }"
                    >Профиль</router-link
                  >
                </li>
                <li class="nav-item nav-item-btn">
                  <router-link
                    v-if="isDeliverer"
                    class="dropdown-item"
                    :to="{ name: 'cards' }"
                    >Банковские карты</router-link
                  >
                </li>
                <li class="nav-item nav-item-btn">
                  <router-link
                    v-if="isDeliverer"
                    class="dropdown-item"
                    :to="{ name: 'payofforders' }"
                    >Журнал выплат</router-link
                  >
                </li>
                <li class="nav-item nav-item-btn">
                  <router-link
                    v-if="isDeliverer"
                    class="dropdown-item"
                    :to="{ name: 'deliveries' }"
                    >Журнал сдачи ягод</router-link
                  >
                </li>
                <li>
                  <a class="dropdown-item btn" @click="userExit">Выход</a>
                </li>
              </ul>
            </li>
            <li class="nav-item nav-item-btn">
              <router-link
                v-if="!userName"
                class="nav-link active btn btn-light fw-bold"
                type="button"
                aria-current="page"
                :to="{ name: 'login' }"
                >Вход</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { useStore } from "vuex";
import { computed, onMounted, onUpdated, nextTick } from "vue";
// import Login from '@/components/Login.vue'
import useCommonMixin from "@/components/commonMixin.js";
import * as bootstrap from "bootstrap";

export default {
  name: "TopPanel",
  components: {
    // Login,
  },
  setup(props) {
    const store = useStore();
    useCommonMixin();
    const { isDeliverer, isReceiver, isAdmin, isManager, isWholesaler, isDriver, isManagerFB } = useCommonMixin();

    const userExit = () => {
      store.commit("removeToken");
      document.location.reload(true);
    };

    const publicPath = () => {
      return process.env.NODE_ENV === "production" ? "/lk/" : "/";
    };

    const navLinksToggle = async () => {
      await nextTick();
      const navLinks = document.querySelectorAll(".nav-item-btn");
      const menuToggle = document.getElementById("navbarNav");
      const bsCollapse = new bootstrap.Collapse(menuToggle, {
        toggle: false,
        show: true, //useless
        hide: false, //useless
      });
      // console.log("bsCollapse", bsCollapse);
      // console.log("navLinks", navLinks);
      navLinks.forEach((l) => {
        // console.log('link', l);
        l.addEventListener("click", () => {
          bsCollapse.toggle();
        });
      });
    };

    onMounted(async () => {
      await store.dispatch("FETCHuserProfile", { userId: null, phone: null });
      await store.dispatch('FETCHberry')
      await navLinksToggle();
    });

    return {
      userExit,
      userName: computed(() => store.getters.userName),
      jwtAccessValid: computed(() => store.getters.jwtAccessValid),
      publicPath,
      isDeliverer,
      isReceiver,
      isAdmin,
      isManager,
      isWholesaler,
      isDriver,
      isManagerFB,
    };
  },
};
</script>

<style scoped>
.modal-title,
.modal-body {
  text-align: center !important;
}
</style>

